import { Media } from 'ca-api-client';

import { mediaImageFilters } from '@/filters/mediaImage';
export default class BeforeAfter {
    config() {
        return {
            title: 'Before / After',
            description: 'Select a before and after image.',
            initialView: 'MediaUpload',
            mode: 'single',
            media: true,
            sets: false,
            upload: {
                allow: true,
                allowMultiple: false,
                onProcessFile: this.addFile,
            },
            defaultFilters: [{ type: 'image' }, { interactive_id: null }, { 360: false }, { public: null }],
            filterOptions: mediaImageFilters,
        };
    }
    addFile(file) {
        // no scope here
        return new Promise((resolve, reject) => {
            const serverJson = JSON.parse(file.serverId).data;
            serverJson.url = file.getFileEncodeDataURL();
            const serverData = new Media(serverJson);
            App.$store.dispatch('prependGalleryMediaSelectItem', serverData).then(() => {
                const options = App.$store.getters.getMediaUploadModalOptions;
                if (!options.allowMultiple) {
                    App.$store.commit('setMediaSelectModalCurrentView', 'MediaSelect');
                    App.$store.commit('setMediaSelectIsLoading', true);
                    App.$store.commit('setMediaSelectLoadingMessage', 'Your upload is processing...');
                }
                resolve(serverData);
            });
        }).catch((error) => {
            console.log(error);
        });
    }
    doAction() {
        const options = App.$store.getters.getMediaSelectOptions;
        const item = App.$store.getters.getMediaSelectCurrentSelection;

        return new Promise((resolve) => {
            App.$store.commit('setMediaEditBeforeAfterMedia', { side: options.side, id: item.id });
            App.$store.dispatch('updateBeforeAfter').then((response) => {
                resolve(response);
            });
        });
    }
}
